export default "assets/images/background-8fa1d5d1.svg";